import { Card, Flex, Form, Input } from 'antd'
import { UploadChangeParam } from 'antd/es/upload'
import { FormInstance, UploadFile } from 'antd/lib'

import { CustomItemRender, Upload } from 'src/components'
import { useLocales } from 'src/locales'

import { LocalReturnsConsumablesTable } from './LocalReturnsConsumablesTable'

type Props = {
  form: FormInstance
  onChange?: (info: UploadChangeParam<UploadFile>) => void
}

export const LocalReturnFormFields = ({ form, onChange }: Props) => {
  const { t } = useLocales()

  return (
    <Flex vertical gap={16}>
      <Card>
        <Form.List name="medicine">
          {(fields, { add, remove }) => (
            <LocalReturnsConsumablesTable
              fields={fields}
              add={add}
              remove={remove}
              form={form}
            />
          )}
        </Form.List>
      </Card>

      <Card>
        <Card title={t('stock_applications.uploaded_documents')}>
          <Form.Item name="docs" className="full-width">
            <Upload
              onChange={onChange}
              customRequest={() => null}
              itemRender={(_, file, __, { remove }) => (
                <CustomItemRender file={file} onRemove={remove} />
              )}
            />
          </Form.Item>
        </Card>
      </Card>

      <Card>
        <Card title={t('common.comment')}>
          <Form.Item name="comment" className="full-width">
            <Input.TextArea rows={5} placeholder={t('common.leave_comment')} />
          </Form.Item>
        </Card>
      </Card>
    </Flex>
  )
}
